<template>
  <div class="gm-admin-tab">
    <div class="gm-admin-tab__head">
      <div>
        <h2>{{ $t('frontend_groovemail_admin_settings_unsubscription_settings') }}</h2>
        <p class="gm-admin-tab__hint">{{ $t('frontend_groovemail_admin_configure_settings') }}</p>
      </div>
      <gs-button variant="primary" @click="updateUnsubcriptionSetting()">{{ $t('frontend_save') }}</gs-button>
    </div>

    <div class="gm-admin-tab__row">
      <gs-field
        class="gs-field--grow"
        :label="`${$t('frontend_groovemail_unsubscription_settings_limit_for_report_abuse')}“${$t('frontend_groovemail_unsubscription_settings_complainer')}”`"
      >
        <text-input
          variant="base"
          v-model="model.reportAbuseCount"
          @input="unsubscriptionSettingsChange = true"
          :placeholder="this.$t('frontend_groovemail_unsubscription_settings_enter_report_abuse_count')"
          :validator="$v.model.reportAbuseCount"
        />
      </gs-field>
      <gs-field
        class="gs-field--grow"
        :label="`${$t('frontend_groovemail_unsubscription_settings_limit_for_spam_blocked')}“${$t('frontend_groovemail_spam_settings_blocked')}”`"
      >
        <text-input
          variant="base"
          v-model="model.spamBlockCount"
          @input="unsubscriptionSettingsChange = true"
          :placeholder="this.$t('frontend_groovemail_unsubscription_settings_enter_report_spam_count')"
          :validator="$v.model.spamBlockCount"
        />
      </gs-field>
    </div>
  </div>
</template>

<script>
import { required, numeric, minValue } from 'vuelidate/lib/validators';
import { adminUrls } from '@/utils/urls.js';
import { getData, postData } from '@/utils/apiHelper.js';
import { showErrorDialog } from '@/components/showDialog.js';

export default {
  data() {
    return {
      model: {
        reportAbuseCount: 0,
        spamBlockCount: 0,
      },
      unsubscriptionSettingsChange: false,
    };
  },

  validations: {
    model: {
      reportAbuseCount: {
        required,
        numeric,
        minValue: minValue(1),
      },
      spamBlockCount: {
        required,
        numeric,
        minValue: minValue(1),
      },
    },
  },

  // Initializes data properties with unsubscription data.
  async created() {
    await this.initializeUnsubscriptionData();
  },

  methods: {
    // Fetches unsubscription data and initializes them to data properties.
    async initializeUnsubscriptionData() {
	    const unsubscriptionData = await getData(
        adminUrls.mainSettingsUrl.fetchAbuseReportLimit
      );
      if (
        unsubscriptionData && 
        unsubscriptionData.data &&
        unsubscriptionData.data['report-abuse-limit-value']
      ) {
        this.model.reportAbuseCount =
          unsubscriptionData.data['report-abuse-limit-value'];
      }
	    const spamlimitData = await getData(
        adminUrls.mainSettingsUrl.fetchSpamBlockedLimit
      );
      if (
        spamlimitData &&
        spamlimitData.data && 
        spamlimitData.data['spam-blocked-limit-value']
      ) {
        this.model.spamBlockCount =
          spamlimitData.data['spam-blocked-limit-value'];
      }
    },

    // Saves Unsubscription data
    async updateUnsubcriptionSetting() {
      this.$v.model.reportAbuseCount.$touch();
      this.$v.model.spamBlockCount.$touch();
      let validity = true;
      validity = !(
            this.$v.model.reportAbuseCount.$invalid ||
            this.$v.model.spamBlockCount.$invalid
      );
      if (this.unsubscriptionSettingsChange) {
        if (validity) {
	        await Promise.all([
            postData(adminUrls.mainSettingsUrl.updateAbuseReportLimit, {
              abuse_report_limit: this.model.reportAbuseCount,
            }),
            postData(adminUrls.mainSettingsUrl.updateSpamBlockedLimit, {
              spam_blocked_limit: this.model.spamBlockCount,
            }),
          ]);
          this.unsubscriptionSettingsChange = false;
        }
      } else {
        await showErrorDialog('', this.$t('frontend_groovemail_admin_unsubscription_mail_settings_update_warning'));       
      }
    },
  },
};
</script>

